// extracted by mini-css-extract-plugin
export var desktopImage = "inline-image-module--desktop-image--cd623";
export var image = "inline-image-module--image--3ba52";
export var mobileImage = "inline-image-module--mobile-image--08615";